import { create } from "zustand";
import { persist } from "zustand/middleware";

// Authenticated storefront customer (separate from staff/admin auth).
export const useCustomer = create(
  persist(
    (set) => ({
      token: null,
      customer: null,
      isAuthed: false,

      setAuth: (token, customer) => set({ token, customer, isAuthed: true }),
      setCustomer: (customer) => set({ customer }),
      logout: () => set({ token: null, customer: null, isAuthed: false }),
    }),
    { name: "altus-customer-auth" }
  )
);
